<template>
  <QuoteProgramWrapperDays
    :quote="quote"
    :editMode="editMode"
    :program="program"
    :routes="routes"
    :images="images"
    :program-pages="programPages"
    :supplier-product-data="supplierProductData"
    @update="updateProgram"
  />
</template>

<script>
import QuoteProgramWrapperDays from "./QuoteProgramWrapperDays";
export default {
  components: {
    QuoteProgramWrapperDays,
  },
  props: {
    quote: {
      type: Object,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    program: {
      type: Object,
    },
    routes: {
      type: Array,
      default: () => [],
    },
    images: {
      type: Array,
    },
    programPages: {
      type: Array,
      default: () => [],
    },
    supplierProductData: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    updateProgram(payload) {
      this.$emit("update", payload);
    },
  },
};
</script>
